import { axiosInstance } from './base'

////////////

function getApiBasePath(): string {
  return `/clinic/api/v1`
}
const basePath = getApiBasePath()

////////////

type getOomDetailReq = {
  orgId: string
  clusterId: string
  contextId: string
}

export function getOOMSummary({
  orgId,
  clusterId,
  contextId
}: getOomDetailReq) {
  const applicationId = orgId
  const targetId = clusterId

  return axiosInstance.get(
    `${basePath}/activityhub/applications/${applicationId}/targets/${targetId}/activitygroups/${contextId}`
  )
}

export function getOOMDetail({ fileKey }: { fileKey: string }) {
  return axiosInstance.get(
    `${basePath}/activityhub/file/view?key=${encodeURIComponent(fileKey)}`
  )
}
